import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The quickreading",
  "description": "",
  "published": "2011-09-10T00:00:00.000Z",
  "redirect_from": ["/blog/the-quickreading/swizec/2414"],
  "categories": "Apple, Claude Shannon, E-book, Information theory, IPad, Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/09/5057005056_6c46df1beb_m.jpg",
        "alt": "Claude Shannon",
        "title": "Claude Shannon"
      }}></img></p>
    <p>{`Today I learned that quickreading scientific text isn't all that quick at all. I have a theoretical exam on `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Information_theory",
        "title": "Information theory"
      }}>{`information theory`}</a>{` on Tuesday and to start off the studying I wanted to read `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Claude_Shannon",
        "title": "Claude Shannon"
      }}>{`Shannon's`}</a>{` original paper on the topic, all 55 pages of it.`}</p>
    <p>{`Seeming as how quickreading is a little bit like opening a broadband pipeline from the text right into my brain ... well turns out quickreading 55 pages liberally sprinkled with `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Formula",
        "title": "Formula"
      }}>{`mathematical formula`}</a>{` takes just over an hour. And I don't feel like I've gotten much out of reading the thing, certainly nothing more than I already had a grasp of studying for the practical part of the exam.`}</p>
    <p>{`At least it was an interesting read.`}</p>
    <p>{`Another thing I discovered today is that with the addition of a wireless keyboard, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/IPad",
        "title": "IPad"
      }}>{`the iPad`}</a>{` is in fact a useful device. Shocker!`}</p>
    <p>{`After my laptop keyboard started spazzing out following the August Spill, I fired up Pages on the iPad and was well on the way ... except for the special `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Slovene_language",
        "title": "Slovene language"
      }}>{`Slovene`}</a>{` letters because the iPad is oh so clever and you can't tell it to use a keyboard layout different than what the keyboard considers native.`}</p>
    <p>{`Silly thing.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.prweb.com/releases/2010/01/prweb3530964.htm"
        }}>{`New Research Shows That American Students Can Only Be Successful in the Digital Age By Reading More`}</a>{` (prweb.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.prweb.com/releases/prweb2010/12/prweb4913104.htm"
        }}>{`QuickReader 3.0 for iOS - Top Selling Speed Reading App Now iPad Native`}</a>{` (prweb.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://b.akumar.me/2011/09/07/ipad-bluetooth-keyword-best-computing-rig-for-economy-class/"
        }}>{`iPad + Bluetooth Keyword = Best computing rig for Economy Class`}</a>{` (b.akumar.me)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://frted.wordpress.com/2011/08/23/knowledge-and-wisdom-fact-and-truth/"
        }}>{`Knowledge and Wisdom, Fact and Truth`}</a>{` (frted.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=e1ce3378-ec4b-471f-a0f6-5855a7b8b22f",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      